import { NotesRef } from "@lifeat/shared/data-models/widget/Notes/NotesDataModel";
import { functions } from "@firebase-local/firebase";
import { NOTES_WIDGET_FUNCTIONS } from "@firebase-local/functions/ServerlessEndpoints";

/**
 * Update the contents of a NotesWidget tab
 * @param {NotesRef} noteRef Reference to the Notes document/instance we are updating
 */
export const updateNote = (noteRef: NotesRef): Promise<any> => {
    return functions.httpsCallable(NOTES_WIDGET_FUNCTIONS.UpdateNote)(noteRef);
};
